export default "__VITE_ASSET__DQftoamN__"